import React from "react";

const ViewAsrs = ({ data, ismodalopen, setHtmlModal }) => {
  if (!ismodalopen || !data || !data.json_data) return null;

  const json = data.json_data;

  const closeModal = () => setHtmlModal(false);

  const questions = [
    { q: "How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done?", key: "qanswer_3_2" },
    { q: "How often do you have difficulty getting things in order when you have to do a task that requires organization?", key: "qanswer_3_3" },
    { q: "How often do you have problems remembering appointments or obligations?", key: "qanswer_3_4" },
    { q: "When you have a task that requires a lot of thought, how often do you avoid or delay getting started?", key: "qanswer_3_5" },
    { q: "How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?", key: "qanswer_3_6" },
    { q: "How often do you feel overly active and compelled to do things, like you were driven by a motor?", key: "qanswer_3_7" },
    { q: "How often do you make careless mistakes when you have to work on a boring or difficult project?", key: "qanswer_3_8" },
    { q: "How often do you have difficulty keeping your attention when you are doing boring or repetitive work?", key: "qanswer_3_9" },
    { q: "How often do you have difficulty concentrating on what people say to you, even when they are speaking to you directly?", key: "qanswer_3_10" },
    { q: "How often do you misplace or have difficulty finding things at home or at work?", key: "qanswer_3_11" },
    { q: "How often are you distracted by activity or noise around you?", key: "qanswer_3_12" },
    { q: "How often do you leave your seat in meetings or other situations in which you are expected to remain seated?", key: "qanswer_3_13" },
    { q: "How often do you feel restless or fidgety?", key: "qanswer_3_14" },
    { q: "How often do you have difficulty unwinding and relaxing when you have time to yourself?", key: "qanswer_3_15" },
    { q: "How often do you find yourself talking too much when you are in social situations?", key: "qanswer_3_16" },
    { q: "When you’re in a conversation, how often do you find yourself finishing the sentences of the people you are talking to, before they can finish them themselves?", key: "qanswer_3_17" },
    { q: "How often do you have difficulty waiting your turn in situations when turn taking is required?", key: "qanswer_3_18" },
    { q: "How often do you interrupt others when they are busy?", key: "qanswer_3_19" },
  ];

  const options = ["Never", "Rarely", "Sometimes", "Often", "Very Often"];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-5xl w-full max-h-[90vh] overflow-y-auto text-start">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">{json.form_name}</h2>
          <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">&times;</button>
        </div>

        {/* Intro */}
        <div className="mb-4">
          <p className="font-bold text-lg mb-2">Adult ADHD Self Report Scale (ASRS-vI.I) Symptom Checklist</p>
          <p className="mb-2 text-gray-700">
            Please answer the questions below, rating yourself on each of the criteria shown using the scale on the right side of the page.
            Select the answer that best describes how you felt and conducted yourself over the past 6 months.
            Please give this completed checklist to your healthcare professional to discuss during today’s appointment.
          </p>
        </div>

        {/* Patient Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="font-bold text-base">Patient Name</label>
            <p>{json.patient_name}</p>
          </div>
          <div>
            <label className="font-bold text-base">Date</label>
            <p>{json.cdate}</p>
          </div>
        </div>

        {/* Questions */}
        {questions.map((q, idx) => (
          <div key={idx} className="mb-4">
            <label className="font-bold text-base">{q.q}</label>
            <div className="flex flex-wrap gap-4 mt-2">
              {options.map((opt) => (
                <span
                  key={opt}
                  className={`px-3 py-1 rounded-full text-sm font-sans border ${
                    json[q.key] === opt
                      ? "bg-blue-600 text-white border-blue-600"
                      : "bg-white border-gray-300 text-black"
                  }`}
                >
                  {opt}
                </span>
              ))}
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default ViewAsrs;
